import { useState } from 'react';
import './LeadsItem.css';
import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';
import { Link } from 'react-router-dom';

export default function LeadsItem({leadItem, user, isMobile, leadsPreferences}) {
    const noteLimit = 10
    const [showMoreNote, setShowMoreNote] = useState(false)
    const handleShowMoreNote = () => {
        setShowMoreNote(!showMoreNote)
    }
  return (
    <tr className='LeadsItem'>
        { !leadsPreferences.includes('leadName') &&
        <td className='leadName'>{capitalizeFirstLetter(leadItem.leadName)}</td>
        }
        { !leadsPreferences.includes('email') &&
        <td className='email'>{leadItem.email}</td>
        }
        { !leadsPreferences.includes('status') &&
        <td className={`leadStatus ${leadItem.status}`}>
            <div className={`statusContainer ${leadItem.status}`}>
                <span className={`statusColor ${leadItem.status}`}></span>
                { leadItem.status === 'dead' &&
                <span className={`statusText ${leadItem.status}`}>Dead</span>
                }
                { leadItem.status === 'active' &&
                <span className={`statusText ${leadItem.status}`}>Active</span>
                }
                { leadItem.status === 'hot' &&
                <span className={`statusText ${leadItem.status}`}>Hot</span>
                }
                { leadItem.status === 'converted' &&
                <span className={`statusText ${leadItem.status}`}>Converted</span>
                }
            </div>
        </td>
        }
        { !leadsPreferences.includes('contactName') &&
        <td className='contactName'>{leadItem.contactName? capitalizeFirstLetter(leadItem.contactName) : '---'}</td>
        }
        { !leadsPreferences.includes('todos') &&
        <td className='todoList'>
            <Link to={`/leads/${leadItem._id}`}>
                <button className='view'>
                    <svg width="20" height="14" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.64935 4C9.75295 4 10.6476 4.89543 10.6476 6C10.6476 7.10457 9.75295 8 8.64935 8C7.54576 8 6.65112 7.10457 6.65112 6C6.65112 4.89543 7.54576 4 8.64935 4Z" fill="#1A5E9B"/>
                        <path d="M17.1227 6.6525C16.168 8.187 14.9294 9.4905 13.5411 10.4224C12.0052 11.4544 10.3095 12 8.63762 12C7.10355 12 5.59509 11.5444 4.1541 10.6459C2.6846 9.72975 1.35329 8.39138 0.196964 6.66825C0.0664255 6.47351 -0.00546743 6.24283 -0.00957887 6.00552C-0.0136903 5.76822 0.0501654 5.535 0.173874 5.3355C1.12672 3.78562 2.35304 2.48025 3.71971 1.56112C5.25847 0.525 6.9145 0 8.63762 0C10.3229 0 12.0222 0.541124 13.5516 1.5645C14.9392 2.49337 16.1752 3.80175 17.1263 5.349C17.2457 5.54386 17.3089 5.77025 17.3082 6.0013C17.3076 6.23235 17.2432 6.45836 17.1227 6.6525ZM8.64989 2.4C7.96486 2.4 7.29521 2.61114 6.72563 3.00671C6.15605 3.40228 5.71211 3.96453 5.44997 4.62234C5.18782 5.28015 5.11923 6.00399 5.25287 6.70232C5.38651 7.40066 5.71638 8.04211 6.20077 8.54558C6.68516 9.04905 7.30231 9.39192 7.97418 9.53083C8.64605 9.66973 9.34246 9.59844 9.97534 9.32597C10.6082 9.05349 11.1492 8.59207 11.5297 8.00005C11.9103 7.40804 12.1135 6.71201 12.1135 6C12.1124 5.04556 11.7472 4.13052 11.0978 3.45562C10.4485 2.78073 9.56817 2.40109 8.64989 2.4Z" fill="#1A5E9B"/>
                    </svg>
                    { !isMobile &&
                    <span>&nbsp;View</span>
                    }
                </button>
            </Link>
        </td>
        }
        { !leadsPreferences.includes('note') &&
        <td className='note'>
            { showMoreNote ? 
            <>
            <span>{leadItem.note? `${leadItem.note}` : '---'}</span>
            { leadItem.note && leadItem.note.length > noteLimit &&
            <>
            <span>&nbsp;</span>
            <span className='limitText' onClick={handleShowMoreNote}>View Less</span>
            </>
            }
            </>
            : 
            <>
            <span>{leadItem.note? `${leadItem.note.substring(0, noteLimit)}`: '---'}</span>
            { leadItem.note && leadItem.note.length > noteLimit &&
            <>
            <span className='primaryText'>&nbsp;...</span>
            <span className='limitText' onClick={handleShowMoreNote}>View More</span>
            </>
            }
            </>
            }
        </td>
        }
        { !leadsPreferences.includes('province') &&
        <td className='province'>{leadItem.province? leadItem.province : '---'}</td>
        }
        { !leadsPreferences.includes('phone') &&
        <td className='phone'>{leadItem.phone? leadItem.phone : '---'}</td>
        }
        { !leadsPreferences.includes('address') &&
        <td className='address'>{leadItem.address? leadItem.address : '---'}</td>
        }
        { !leadsPreferences.includes('source') &&
        <td className='source'>{leadItem.source? capitalizeFirstLetter(leadItem.source) : '---'}</td>
        }
        { !leadsPreferences.includes('createdAt') &&
        <td className='createdAt'>{new Date(leadItem.createdAt).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })}</td>
        }
        { !leadsPreferences.includes('updatedAt') &&
        <td className='lastUpdate'>{new Date(leadItem.updatedAt).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })}</td>
        }
        <td className='actions'>
            <div className='actionButtonContainer'>
                { leadItem.status !== 'converted' ?
                <button className='conversionButton' title='Convert to Client' data-bs-toggle="modal" data-bs-target={`#convertLeadModal${leadItem._id}`}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#0A7637" className="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16" opacity={0.7}>
                        <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z"/>
                    </svg>
                </button>
                :
                <button className='convertedButton' title='Client Converted' disabled>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#8993A1" className="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16" opacity={0.7}>
                        <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z"/>
                    </svg>
                </button>
                }
                <button className={`updateButton ${leadItem.status==='converted' && 'disabled'}`} title='Update Lead' data-bs-toggle="modal" data-bs-target={`#updateLeadModal${leadItem._id}`} disabled={leadItem.status==='converted'}>
                    <svg width="30" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M25.3924 23.4533C25.8971 23.4533 26.3076 23.8692 26.3076 24.3805C26.3076 24.8927 25.8971 25.3076 25.3924 25.3076H20.2192C19.7144 25.3076 19.3039 24.8927 19.3039 24.3805C19.3039 23.8692 19.7144 23.4533 20.2192 23.4533H25.3924ZM21.8048 9.63334L23.1411 10.6949C23.6891 11.1234 24.0544 11.6883 24.1794 12.2824C24.3236 12.9358 24.1698 13.5776 23.7372 14.1328L15.7769 24.4269C15.4116 24.8944 14.8732 25.1573 14.2963 25.1671L11.1238 25.206C10.9507 25.206 10.8065 25.0892 10.7681 24.9236L10.047 21.7974C9.92204 21.2228 10.047 20.6287 10.4123 20.171L16.0557 12.8667C16.1518 12.7498 16.3249 12.7313 16.4402 12.818L18.8149 14.7074C18.9687 14.834 19.1802 14.9022 19.4013 14.8729C19.8724 14.8145 20.1896 14.386 20.1416 13.9282C20.1127 13.6945 19.9974 13.4997 19.8435 13.3536C19.7955 13.3147 17.5362 11.5032 17.5362 11.5032C17.392 11.3864 17.3632 11.1721 17.4785 11.027L18.3726 9.86707C19.1994 8.80552 20.6415 8.70813 21.8048 9.63334Z" fill="#1A5E9B"/>
                        <rect x="1" y="1" width="33" height="33" rx="7" stroke="#1A5E9B" strokeOpacity="0.24" strokeWidth="2"/>
                    </svg>
                </button>
                <button className='deleteButton' title='Delete Lead' data-bs-toggle="modal" data-bs-target={`#deleteLeadModal${leadItem._id}`}>
                    <svg width="30" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="1" y="1" width="33" height="33" rx="7" stroke="#CA150C" strokeOpacity="0.24" strokeWidth="2"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M23.7366 15.3519C23.7366 15.0989 23.5313 14.8936 23.2783 14.8936H11.182C10.9281 14.8936 10.7237 15.0989 10.7237 15.3519C10.7237 16.2658 10.7072 17.1174 10.6916 17.9066C10.6238 21.3432 10.5788 23.6138 11.9676 25.0301C12.9539 26.0356 14.5737 26.4848 17.2201 26.4848C19.8692 26.4848 21.4917 26.0347 22.4808 25.0273C23.876 23.6046 23.832 21.3231 23.7669 17.8672C23.7522 17.089 23.7366 16.2502 23.7366 15.3519Z" fill="#CA150C"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M24.6313 11.847H20.8354C20.7978 11.2475 20.6319 10.4023 20.0351 9.71663C19.4044 8.99155 18.4603 8.62305 17.2283 8.62305C15.9972 8.62305 15.0531 8.99155 14.4224 9.71663C13.8256 10.4023 13.6588 11.2475 13.6212 11.847H9.82715C9.44765 11.847 9.13965 12.155 9.13965 12.5345C9.13965 12.914 9.44765 13.222 9.82715 13.222H24.6313C25.0108 13.222 25.3188 12.914 25.3188 12.5345C25.3188 12.155 25.0108 11.847 24.6313 11.847Z" fill="#CA150C"/>
                    </svg>
                </button>
            </div>
            
        </td>
    </tr>
  )
}
